module.exports = __webpack_public_path__ + "img/app-icon-02.4068b21a.svg";